"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKOUT_OPTION_KEY = exports.SUMMARY_ITEM_TYPES = exports.ProductIds = exports.CURRENCY_CONVERSIONS = void 0;
// Last updated at 13 Mar 2024, source: Gooogle Rates
exports.CURRENCY_CONVERSIONS = {
    CAD: 1.35,
    GBP: 0.78,
    EUR: 0.91,
    ILS: 3.67,
    SEK: 10.24,
    DKK: 6.82,
    AUD: 1.51,
    MXN: 16.78,
    ARS: 847.01,
    INR: 82.88,
    CLP: 961.22,
    PLN: 3.92,
    JPY: 147.71,
    USD: 1.0,
    GHS: 12.83,
    RON: 4.54,
    AFN: 71.0,
    SGD: 1.33,
    XPF: 109.7,
    NGN: 1612.78,
    PHP: 55.38,
    SAR: 3.75,
    ZAR: 18.61,
    AED: 3.67,
    UAH: 38.8,
    CHF: 0.88,
    VND: 24724.5,
    XCD: 2.7,
    VED: 36.1755,
    QAR: 3.64,
    PYG: 7301.78,
    NZD: 1.64,
    NOK: 10.61,
    MYR: 4.7045,
    MAD: 10.03,
    ISK: 136.61,
    HUF: 360.8,
    HNL: 24.7,
    HKD: 7.82,
    DOP: 59.18,
    COP: 3894.31,
    BHD: 0.38,
    AOA: 836.5,
};
// These are the product ids for the gift card products, which are not in the pricing items db, because their price is not constant
var ProductIds;
(function (ProductIds) {
    ProductIds["GIFT_CARD_VALUE"] = "GIFT_CARD_VALUE";
    ProductIds["GIFT_CARD_TILES"] = "GIFT_CARD_TILES";
    ProductIds["SKU_TILES"] = "SKU_TILES";
    ProductIds["MIXTILES_PLUS"] = "MIXTILES_PLUS";
})(ProductIds = exports.ProductIds || (exports.ProductIds = {}));
var SUMMARY_ITEM_TYPES;
(function (SUMMARY_ITEM_TYPES) {
    SUMMARY_ITEM_TYPES["PRODUCT"] = "product";
    SUMMARY_ITEM_TYPES["SHIPPING"] = "shipping";
    SUMMARY_ITEM_TYPES["TAX"] = "tax";
    SUMMARY_ITEM_TYPES["CREDITS"] = "credits";
    SUMMARY_ITEM_TYPES["GIFT_CARD"] = "giftCard";
    SUMMARY_ITEM_TYPES["REQUIREMENT"] = "requirement";
    SUMMARY_ITEM_TYPES["MIXTILES_PLUS"] = "mixtilesPlus";
    SUMMARY_ITEM_TYPES["MIXTILES_PLUS_DISCOUNT"] = "mixtilesPlusDiscount";
})(SUMMARY_ITEM_TYPES = exports.SUMMARY_ITEM_TYPES || (exports.SUMMARY_ITEM_TYPES = {}));
// The possible types of checkout options, saved in the checkout collection
var CHECKOUT_OPTION_KEY;
(function (CHECKOUT_OPTION_KEY) {
    CHECKOUT_OPTION_KEY["FREE"] = "FREE";
    CHECKOUT_OPTION_KEY["EXPEDITED"] = "EXPEDITED";
    CHECKOUT_OPTION_KEY["GIFT_CARD"] = "GIFT_CARD";
})(CHECKOUT_OPTION_KEY = exports.CHECKOUT_OPTION_KEY || (exports.CHECKOUT_OPTION_KEY = {}));
//# sourceMappingURL=pricing.js.map